import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./importquestions.css";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import MultiSeledDropdown from "../CreateQuestionsPaper/MultiDropdown/MultiSeledDropdown";
import SuccessImg from "../../Assets/Images/CommanImages/Informative.png"
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import WarnningIcon from "../../Assets/Images/CommanImages/Warning.png";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs"
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import EndPoints from "../../Api/Endpoints"
import { POST, GET } from "../../Api/HttpsMethods";
import { FaFileImport } from "react-icons/fa6";

function ImportQuestions({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const projectedSectionRef = useRef(null);
  const { coursesdata = [] } = useSelector((state) => state.course) || {};
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isStatusOpen, setIsStatusOpen] = useState(true);
  const [isCriteriaOpen, setIsCriteriaOpen] = useState(false);
  const [importType, setImportType] = useState('incremental');
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [lastUpdatedDate, setLastUpdatedDate] = useState('');
  const [selectedSubjectsForDate, setSelectedSubjectsForDate] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [expandedChapters, setExpandedChapters] = useState({});
  const [checkedSubjects, setCheckedSubjects] = useState({});
  const [checkedChapters, setCheckedChapters] = useState({});
  const [checkedTopics, setCheckedTopics] = useState({});
  const [deltaIds, setDeltaIds] = useState([]);
  const [totals, setTotals] = useState({});
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState([]);
  const [topicOptions, setTopicOptions] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [rangeValue, setRangeValue] = useState("");
  const [setOptions, setSetOptions] = useState([]);
  const [selectedSets, setSelectedSets] = useState([]);
  const [filteredQuestionsByRange, setFilteredQuestionsByRange] = useState([]);
  const [importFilterPayload, setImportFilterPayload] = useState({
    subject_ids: [],
    chapter_ids: [],
    topic_ids: []
  });

  const [isImporting, setIsImporting] = useState(false);
  const isImportEnabled = () => {
    return selectedCourse && projectedData.length > 0 && !isImporting;
  };

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  useEffect(() => {
    if (selectedCourse) {
      fetchSubjectsData();
    }
  }, [selectedCourse]);

  const [initialDeltaCounts, setInitialDeltaCounts] = useState({});

  const fetchSubjectsData = async () => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_QUESTION_BANK_STATUS}?course_id=${selectedCourse}`;
      const data = await POST.withToken(API_ENDPOINT, {});
      if (!data) return;

      setSubjectsData(data.subjects || []);
      setDeltaIds(data.delta_question_ids || []);
      setTotals({
        source: data.total_source_questions || 0,
        destination: data.total_destination_questions || 0,
        delta: data.total_delta || 0,
      });

      const initialDeltas = {};
      (data.subjects || []).forEach((subject) => {
        initialDeltas[`subject_${subject.subject_id}`] = subject.delta_count || 0;

        (subject.chapters || []).forEach((chapter) => {
          initialDeltas[`chapter_${subject.subject_id}_${chapter.chapter_id}`] = chapter.delta_count || 0;

          (chapter.topics || []).forEach((topic) => {
            initialDeltas[`topic_${subject.subject_id}_${chapter.chapter_id}_${topic.topic_id}`] = topic.delta_count || 0;
          });
        });
      });

      setInitialDeltaCounts(initialDeltas);


    } catch (err) {
      console.error(err);
    }
  };

  // ===== FETCH SUBJECTS BY COURSE =====
  useEffect(() => {
    if (!selectedCourse) {
      setSubjectOptions([]);
      setSelectedSubjects([]);
      setChapterOptions([]);
      setSelectedChapters([]);
      setTopicOptions([]);
      return;
    }

    const fetchSubjectsByCourse = async () => {
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourse}`;
        const data = await GET.withToken(API_ENDPOINT);

        if (!Array.isArray(data)) {
          console.error("Expected array but got:", data);
          return;
        }

        const options = data.map((subject) => ({
          label: subject.subject_name,
          id: subject.subject_id,
        }));

        setSubjectOptions(options);
        setSelectedSubjects([]);
        setChapterOptions([]);
        setSelectedChapters([]);
        setTopicOptions([]);
      } catch (err) {
        console.error("Error fetching subjects:", err);
        setSubjectOptions([]);
      }
    };

    fetchSubjectsByCourse();
  }, [selectedCourse]);

  // ===== FETCH CHAPTERS WHEN SUBJECTS ARE SELECTED =====
  useEffect(() => {
    if (!selectedSubjects || selectedSubjects.length === 0) {
      setChapterOptions([]);
      setSelectedChapters([]);
      setTopicOptions([]);
      return;
    }

  const fetchChaptersBySubjects = async () => {
      try {
        const API_ENDPOINT = EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT_IDS;

        // POST body → [1,2,4,7]
        const response = await POST.withToken(API_ENDPOINT, selectedSubjects);

        if (!response || !Array.isArray(response.data)) {
          console.error("Invalid chapter response:", response);
          setChapterOptions([]);
          return;
        }

        const options = response.data.map((chapter) => ({
          label: chapter.chapter_name,
          id: chapter.chapter_id,
          subject_id: chapter.subject_id, // useful later
        }));

        setChapterOptions(options);
        setSelectedChapters([]);
        setTopicOptions([]);
      } catch (err) {
        console.error("Error fetching chapters:", err);
        setChapterOptions([]);
      }
    };

    fetchChaptersBySubjects();
  }, [selectedSubjects]);

  // ===== FETCH TOPICS WHEN CHAPTERS ARE SELECTED =====
  useEffect(() => {
    if (!selectedChapters || selectedChapters.length === 0) {
      setTopicOptions([]);
      return;
    }

    const fetchTopicsByChapters = async () => {
      try {
        const API_ENDPOINT = EndPoints.PRISM_GET_TOPICS_BY_CHAPTER_LIST;
        const response = await POST.withToken(API_ENDPOINT, selectedChapters);

        if (!response || !Array.isArray(response.data)) {
          console.error("Invalid topics response:", response);
          setTopicOptions([]);
          return;
        }

        const options = response.data.map((topic) => ({
          label: topic.topic_name,
          id: topic.topic_id,
          chapter_id: topic.chapter_id, // helpful for filtering later
        }));

        setTopicOptions(options);
      } catch (err) {
        console.error("Error fetching topics:", err);
        setTopicOptions([]);
      }
    };

    fetchTopicsByChapters();
  }, [selectedChapters]);



  useEffect(() => {
    const fetchParseQuesSets = async () => {
      try {
        const result = await GET.withToken(
          EndPoints.PRISM_GET_PARSE_QUES_SET_ALL_CB
        );
        const options = (result?.data || []).map((item) => ({
          label: `${item.parse_ques_set_name} (${item.question_count})`,
          id: item.parse_ques_set_id,
        }));

        setSetOptions(options);
      } catch (error) {
        console.error("Error fetching parse ques sets:", error);
        setSetOptions([]);
      }
    };

    fetchParseQuesSets();
  }, []);

  const toggleExpandSubject = (subjectId) => {
    setExpandedSubjects(prev => ({
      ...prev,
      [subjectId]: !prev[subjectId]
    }));
  };

  const toggleExpandChapter = (subjectId, chapterId) => {
    const key = `${subjectId}-${chapterId}`;
    setExpandedChapters(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSubjectCheck = (subjectId) => {
    const subject = subjectsData.find(s => s.subject_id === subjectId);
    const isCurrentlyChecked = checkedSubjects[subjectId];

    setCheckedSubjects(prev => ({
      ...prev,
      [subjectId]: !isCurrentlyChecked
    }));

    // If subject is being checked, auto-check all its chapters and topics
    if (!isCurrentlyChecked) {
      const newCheckedChapters = { ...checkedChapters };
      const newCheckedTopics = { ...checkedTopics };

      if (subject && subject.chapters) {
        subject.chapters.forEach(chapter => {
          const chapterKey = `${subjectId}-${chapter.chapter_id}`;
          newCheckedChapters[chapterKey] = true;

          // Also check all topics in this chapter
          if (chapter.topics) {
            chapter.topics.forEach(topic => {
              const topicKey = `${subjectId}-${chapter.chapter_id}-${topic.topic_id}`;
              newCheckedTopics[topicKey] = true;
            });
          }
        });
      }

      setCheckedChapters(newCheckedChapters);
      setCheckedTopics(newCheckedTopics);
    } else {
      // If subject is being unchecked, uncheck all its chapters and topics
      const newCheckedChapters = { ...checkedChapters };
      const newCheckedTopics = { ...checkedTopics };

      if (subject && subject.chapters) {
        subject.chapters.forEach(chapter => {
          const chapterKey = `${subjectId}-${chapter.chapter_id}`;
          delete newCheckedChapters[chapterKey];

          // Also uncheck all topics in this chapter
          if (chapter.topics) {
            chapter.topics.forEach(topic => {
              const topicKey = `${subjectId}-${chapter.chapter_id}-${topic.topic_id}`;
              delete newCheckedTopics[topicKey];
            });
          }
        });
      }

      setCheckedChapters(newCheckedChapters);
      setCheckedTopics(newCheckedTopics);
    }
  };

  const handleChapterCheck = (subjectId, chapterId) => {
    const chapterKey = `${subjectId}-${chapterId}`;
    const chapter = subjectsData
      .find(s => s.subject_id === subjectId)
      ?.chapters.find(c => c.chapter_id === chapterId);

    const isCurrentlyChecked = checkedChapters[chapterKey];

    setCheckedChapters(prev => ({
      ...prev,
      [chapterKey]: !isCurrentlyChecked
    }));

    // If chapter is being checked, auto-check all its topics
    if (!isCurrentlyChecked) {
      const newCheckedTopics = { ...checkedTopics };

      if (chapter && chapter.topics) {
        chapter.topics.forEach(topic => {
          const topicKey = `${subjectId}-${chapterId}-${topic.topic_id}`;
          newCheckedTopics[topicKey] = true;
        });
      }
      setCheckedTopics(newCheckedTopics);
    } else {
      // If chapter is being unchecked, uncheck all its topics
      const newCheckedTopics = { ...checkedTopics };

      if (chapter && chapter.topics) {
        chapter.topics.forEach(topic => {
          const topicKey = `${subjectId}-${chapterId}-${topic.topic_id}`;
          delete newCheckedTopics[topicKey];
        });
      }

      setCheckedTopics(newCheckedTopics);
    }
  };

  const handleTopicCheck = (subjectId, chapterId, topicId) => {
    const key = `${subjectId}-${chapterId}-${topicId}`;
    setCheckedTopics(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };


  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const toggleStatusAccordion = () => {
    setIsStatusOpen(!isStatusOpen);
  };

  const toggleCriteriaAccordion = () => {
    setIsCriteriaOpen(!isCriteriaOpen);
  };

  const [projectedData, setProjectedData] = useState([]);
  const [projectedTotals, setProjectedTotals] = useState({});
  const [isProjectedOpen, setIsProjectedOpen] = useState(true);
  const [expandedProjectedSubjects, setExpandedProjectedSubjects] = useState({});
  const [expandedProjectedChapters, setExpandedProjectedChapters] = useState({});
  const [checkedProjectedSubjects, setCheckedProjectedSubjects] = useState({});
  const [checkedProjectedChapters, setCheckedProjectedChapters] = useState({});
  const [checkedProjectedTopics, setCheckedProjectedTopics] = useState({});

  const toggleProjectedAccordion = () => {
    setIsProjectedOpen(!isProjectedOpen);
  };

  const fetchProjectedData = async (payload) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_QUESTION_BANK_STATUS}?course_id=${selectedCourse}`;
      const data = await POST.withToken(API_ENDPOINT, payload);
      if (!data) return;

      // Filter subjects based on the payload
      let filteredSubjects = data.subjects || [];

      // If topic_ids are specified, filter to show only those topics
      if (payload.topic_ids && payload.topic_ids.length > 0) {
        filteredSubjects = filteredSubjects.map(subject => ({
          ...subject,
          chapters: (subject.chapters || []).map(chapter => ({
            ...chapter,
            topics: (chapter.topics || []).filter(topic =>
              payload.topic_ids.includes(topic.topic_id)
            )
          })).filter(chapter => chapter.topics.length > 0)
        })).filter(subject => subject.chapters.length > 0);
      }
      // If chapter_ids are specified, filter to show only those chapters
      else if (payload.chapter_ids && payload.chapter_ids.length > 0) {
        filteredSubjects = filteredSubjects.map(subject => ({
          ...subject,
          chapters: (subject.chapters || []).filter(chapter =>
            payload.chapter_ids.includes(chapter.chapter_id)
          )
        })).filter(subject => subject.chapters.length > 0);
      }
      // If subject_ids are specified, filter to show only those subjects
      else if (payload.subject_ids && payload.subject_ids.length > 0) {
        filteredSubjects = filteredSubjects.filter(subject =>
          payload.subject_ids.includes(subject.subject_id)
        );
      }

      const projecteddataWithCalculations = filteredSubjects.map((subject) => ({
        ...subject,
        new_questions: subject.delta_count,
        updated_questions: subject.delta_count || 0,
        projected_total: (subject.destination_question_count || 0) + (subject.delta_count || 0),
        chapters: (subject.chapters || []).map((chapter) => ({
          ...chapter,
          new_questions: chapter.delta_count,
          updated_questions: 0,
          projected_total: (chapter.destination_question_count || 0) + (chapter.delta_count || 0),
          topics: (chapter.topics || []).map((topic) => ({
            ...topic,
            new_questions: topic.delta_count,
            updated_questions: 0,
            projected_total: (topic.destination_question_count || 0) + (topic.delta_count || 0),
          })),
        })),
      }));

      setProjectedData(projecteddataWithCalculations);
      setProjectedTotals({
        newQuestions: data.total_delta,
        updatedQuestions: 0,
        projectedTotal: (data.total_destination_questions || 0) + (data.total_delta || 0),
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setProjectedData([]);
    setProjectedTotals({});
    setExpandedProjectedSubjects({});
    setExpandedProjectedChapters({});
    setCheckedProjectedSubjects({});
    setCheckedProjectedChapters({});
    setCheckedProjectedTopics({});
    setInitialDeltaCounts({});
  }, [selectedCourse]);

  
  useEffect(() => {
    if (projectedData.length > 0 && projectedSectionRef.current) {
      setTimeout(() => {
        projectedSectionRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
        if (!isProjectedOpen) {
          setIsProjectedOpen(true);
        }
      }, 100);
    }
  }, [projectedData]);

  // Toggle functions for PROJECTED section
  const toggleExpandProjectedSubject = (subjectId) => {
    setExpandedProjectedSubjects(prev => ({
      ...prev,
      [subjectId]: !prev[subjectId]
    }));
  };

  const toggleExpandProjectedChapter = (subjectId, chapterId) => {
    const key = `${subjectId}-${chapterId}`;
    setExpandedProjectedChapters(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Checkbox handlers for PROJECTED section
  const handleProjectedSubjectCheck = (subjectId) => {
    const subject = projectedData.find(s => s.subject_id === subjectId);
    const isCurrentlyChecked = checkedProjectedSubjects[subjectId];

    setCheckedProjectedSubjects(prev => ({
      ...prev,
      [subjectId]: !isCurrentlyChecked
    }));

    if (!isCurrentlyChecked) {
      const newCheckedChapters = { ...checkedProjectedChapters };
      const newCheckedTopics = { ...checkedProjectedTopics };

      if (subject && subject.chapters) {
        subject.chapters.forEach(chapter => {
          const chapterKey = `${subjectId}-${chapter.chapter_id}`;
          newCheckedChapters[chapterKey] = true;

          if (chapter.topics) {
            chapter.topics.forEach(topic => {
              const topicKey = `${subjectId}-${chapter.chapter_id}-${topic.topic_id}`;
              newCheckedTopics[topicKey] = true;
            });
          }
        });
      }

      setCheckedProjectedChapters(newCheckedChapters);
      setCheckedProjectedTopics(newCheckedTopics);
    } else {
      const newCheckedChapters = { ...checkedProjectedChapters };
      const newCheckedTopics = { ...checkedProjectedTopics };

      if (subject && subject.chapters) {
        subject.chapters.forEach(chapter => {
          const chapterKey = `${subjectId}-${chapter.chapter_id}`;
          delete newCheckedChapters[chapterKey];

          if (chapter.topics) {
            chapter.topics.forEach(topic => {
              const topicKey = `${subjectId}-${chapter.chapter_id}-${topic.topic_id}`;
              delete newCheckedTopics[topicKey];
            });
          }
        });
      }

      setCheckedProjectedChapters(newCheckedChapters);
      setCheckedProjectedTopics(newCheckedTopics);
    }
  };

  const handleProjectedChapterCheck = (subjectId, chapterId) => {
    const chapterKey = `${subjectId}-${chapterId}`;
    const chapter = projectedData
      .find(s => s.subject_id === subjectId)
      ?.chapters?.find(c => c.chapter_id === chapterId);

    const isCurrentlyChecked = checkedProjectedChapters[chapterKey];

    setCheckedProjectedChapters(prev => ({
      ...prev,
      [chapterKey]: !isCurrentlyChecked
    }));

    if (!isCurrentlyChecked) {
      const newCheckedTopics = { ...checkedProjectedTopics };

      if (chapter && chapter.topics) {
        chapter.topics.forEach(topic => {
          const topicKey = `${subjectId}-${chapterId}-${topic.topic_id}`;
          newCheckedTopics[topicKey] = true;
        });
      }
      setCheckedProjectedTopics(newCheckedTopics);
    } else {
      const newCheckedTopics = { ...checkedProjectedTopics };

      if (chapter && chapter.topics) {
        chapter.topics.forEach(topic => {
          const topicKey = `${subjectId}-${chapterId}-${topic.topic_id}`;
          delete newCheckedTopics[topicKey];
        });
      }

      setCheckedProjectedTopics(newCheckedTopics);
    }
  };

  const handleProjectedTopicCheck = (subjectId, chapterId, topicId) => {
    const key = `${subjectId}-${chapterId}-${topicId}`;
    setCheckedProjectedTopics(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };


  const handleApply = () => {
    if (!selectedCourse) {
      alert('Please select a course first');
      return;
    }

    let payload = {
      from_date: "",
      subject_ids: [],
      chapter_ids: [],
      topic_ids: [],
      parse_ques_set_question_ids: []
    };

    if (importType === 'incremental') {
      payload.subject_ids = selectedSubjects;
      payload.chapter_ids = selectedChapters;
      payload.topic_ids = selectedTopics;
    } else if (importType === 'specific') {
      const filteredIds = parseRangeInput(rangeValue);
      setFilteredQuestionsByRange(filteredIds);

      if (filteredIds.length === 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>No valid question IDs found in the specified range!</span>
            </div>
          </div>
        );
        setActiveImg(WarnningIcon);
        return;
      }
      payload.parse_ques_set_question_ids = filteredIds;
    } else if (importType === 'date') {
      payload.from_date = lastUpdatedDate;
      payload.subject_ids = selectedSubjectsForDate;
    } else if (importType === 'byset') {
      payload.parse_ques_set_question_ids = selectedSets;
    }

    // Store the payload for filtering
    setImportFilterPayload(payload);
    fetchProjectedData(payload);
  };


  // Add this helper function before the component's return statement
  const collectQuestionIds = (useProjectedData = false, forSync = false) => {
    const questionIds = [];
    const dataSource = useProjectedData ? projectedData : subjectsData;
    const checkedSubjectsSource = useProjectedData ? checkedProjectedSubjects : checkedSubjects;
    const checkedChaptersSource = useProjectedData ? checkedProjectedChapters : checkedChapters;
    const checkedTopicsSource = useProjectedData ? checkedProjectedTopics : checkedTopics;

    dataSource.forEach((subject) => {
      if (forSync) {
        // For SYNC: Get all question IDs from all chapters and topics
        if (subject.chapters) {
          subject.chapters.forEach((chapter) => {
            if (chapter.topics) {
              chapter.topics.forEach((topic) => {
                if (topic.question_ids) {
                  questionIds.push(...topic.question_ids);
                }
              });
            }
          });
        }
      } else {
        // For IMPORT: Get only checked items
        const isSubjectChecked = checkedSubjectsSource[subject.subject_id];

        if (isSubjectChecked && subject.chapters) {
          subject.chapters.forEach((chapter) => {
            const chapterKey = `${subject.subject_id}-${chapter.chapter_id}`;
            const isChapterChecked = checkedChaptersSource[chapterKey];

            if (isChapterChecked && chapter.topics) {
              chapter.topics.forEach((topic) => {
                const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                const isTopicChecked = checkedTopicsSource[topicKey];

                if (isTopicChecked && topic.question_ids) {
                  questionIds.push(...topic.question_ids);
                }
              });
            }
          });
        }
      }
    });

    return [...new Set(questionIds)]; // Remove duplicates
  };


  const handleSyncAll = async () => {
    if (!selectedCourse) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Please select a course first!</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Collect ALL question IDs from CURRENT STATUS section (regardless of checkboxes)
    const questionIds = collectQuestionIds(false, true);

    if (questionIds.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>No questions available to sync!</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Show confirmation dialog
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Are you sure you want to sync all {questionIds.length} questions? This will update the sync history.</span>
        </div>
        <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              performSync(questionIds); // Call the actual sync function
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(WarnningIcon); // Make sure to import this
  };

  // Separate function to perform the actual sync
  const performSync = async (questionIds) => {
    try {
      const API_ENDPOINT = EndPoints.PRISM_SYNC_HISTORY;
      const payload = {
        question_ids: questionIds
      };

      const response = await POST.withToken(API_ENDPOINT, payload);

      if (response) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>Successfully synced all {questionIds.length} questions!</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);

        // Refresh the status data
        await fetchSubjectsData();

        // Clear selections after successful sync
        // setCheckedSubjects({});
        // setCheckedChapters({});
        // setCheckedTopics({});
        setCheckedSubjects({});
        setCheckedChapters({});
        setCheckedTopics({});
        setRangeValue("");
        setFilteredQuestionsByRange([]);
      }
    } catch (err) {
      console.error('Error syncing questions:', err);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Failed to sync questions. Please try again.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  const handleImport = async () => {
      if (!selectedCourse) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>Please select a course first!</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      let questionIds = [];
      if (importType === "specific") {
        questionIds = filteredQuestionsByRange;
      } else {
        questionIds = collectQuestionIds(false, false);
      }

      if (questionIds.length === 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>Please select at least one subject, chapter, or topic to import!</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }
      setIsImporting(true);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Questions are importing...</span>
          </div>
        </div>
      );

      try {
        const API_ENDPOINT = EndPoints.PRISM_IMPORT_QUESTIONS;
        const payload = {
          parse_ques_set_question_ids: questionIds,
        };

        const response = await POST.withToken(API_ENDPOINT, payload);
        if (response) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Successfully imported {questionIds.length} questions!</span>
              </div>
            </div>
          );
          setActiveImg(SuccessImg);
          setCheckedSubjects({});
          setCheckedChapters({});
          setCheckedTopics({});
          setSelectedSubjects([]);
          setSelectedChapters([]);
          setSelectedTopics([]);
          setRangeValue("");
          setFilteredQuestionsByRange([]);
          window.location.reload();
        }
      } catch (err) {
        console.error("Error importing questions:", err);
        setIsImporting(false);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>Failed to import questions. Please try again.</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      }
  };

  // ===== PARSE AND FILTER QUESTION IDS BY RANGE =====
  const parseRangeInput = (rangeString) => {
    if (!rangeString.trim()) return [];

    const questionIds = new Set();
    const parts = rangeString.split(',').map(part => part.trim());

    for (const part of parts) {
      if (part.includes('-')) {
        // Handle range like "1000-1500"
        const [start, end] = part.split('-').map(num => parseInt(num.trim()));

        if (!isNaN(start) && !isNaN(end)) {
          const min = Math.min(start, end);
          const max = Math.max(start, end);

          // Add all IDs in range that exist in deltaIds
          for (let i = min; i <= max; i++) {
            if (deltaIds.includes(i)) {
              questionIds.add(i);
            }
          }
        }
      } else {
        // Handle single ID like "100"
        const id = parseInt(part);
        if (!isNaN(id) && deltaIds.includes(id)) {
          questionIds.add(id);
        }
      }
    }

    return Array.from(questionIds);
  };

  // REMOVE the old useEffect that syncs checked items and replace with this:
  useEffect(() => {
    if (importType !== 'incremental') return;

    const checkedSubjectIds = Object.keys(checkedSubjects)
      .filter(key => checkedSubjects[key] === true)
      .map(id => parseInt(id));

    const checkedChapterIds = [];
    Object.keys(checkedChapters).forEach(chapterKey => {
      if (checkedChapters[chapterKey] === true) {
        const [, chapterId] = chapterKey.split('-');
        if (!checkedChapterIds.includes(parseInt(chapterId))) {
          checkedChapterIds.push(parseInt(chapterId));
        }
      }
    });

    const checkedTopicIds = [];
    Object.keys(checkedTopics).forEach(topicKey => {
      if (checkedTopics[topicKey] === true) {
        const parts = topicKey.split('-');
        const topicId = parseInt(parts[2]);
        if (!checkedTopicIds.includes(topicId)) {
          checkedTopicIds.push(topicId);
        }
      }
    });

    // Only update if values actually changed
    const subjectsChanged = JSON.stringify(checkedSubjectIds.sort((a,b) => a-b)) !== 
                            JSON.stringify(selectedSubjects.sort((a,b) => a-b));
    const chaptersChanged = JSON.stringify(checkedChapterIds.sort((a,b) => a-b)) !== 
                            JSON.stringify(selectedChapters.sort((a,b) => a-b));
    const topicsChanged = JSON.stringify(checkedTopicIds.sort((a,b) => a-b)) !== 
                          JSON.stringify(selectedTopics.sort((a,b) => a-b));

    if (subjectsChanged) {
      setSelectedSubjects(checkedSubjectIds);
    }
    if (chaptersChanged) {
      setSelectedChapters(checkedChapterIds);
    }
    if (topicsChanged) {
      setSelectedTopics(checkedTopicIds);
    }

  }, [checkedSubjects, checkedChapters, checkedTopics, importType]);


  // AND add this new useEffect to handle dropdown to checkbox sync with auto-select logic
  useEffect(() => {
    if (importType !== 'incremental') return;

    const newCheckedSubjects = {};
    const newCheckedChapters = {};
    const newCheckedTopics = {};

    // Check all selected subjects
    selectedSubjects.forEach(subjectId => {
      newCheckedSubjects[subjectId] = true;
    });

    // Auto-select ALL chapters if subject selected but no chapter selected
    if (selectedSubjects.length > 0 && selectedChapters.length === 0) {
      selectedSubjects.forEach(subjectId => {
        const subject = subjectsData.find(s => s.subject_id === subjectId);
        if (subject?.chapters) {
          subject.chapters.forEach(chapter => {
            const chapterKey = `${subjectId}-${chapter.chapter_id}`;
            newCheckedChapters[chapterKey] = true;

            // Auto-select ALL topics
            if (chapter.topics) {
              chapter.topics.forEach(topic => {
                const topicKey = `${subjectId}-${chapter.chapter_id}-${topic.topic_id}`;
                newCheckedTopics[topicKey] = true;
              });
            }
          });
        }
      });
    }
    // Auto-select ALL topics if chapters selected but no topics selected
    else if (selectedSubjects.length > 0 && selectedChapters.length > 0 && selectedTopics.length === 0) {
      selectedSubjects.forEach(subjectId => {
        const subject = subjectsData.find(s => s.subject_id === subjectId);
        
        selectedChapters.forEach(chapterId => {
          const chapterKey = `${subjectId}-${chapterId}`;
          newCheckedChapters[chapterKey] = true;

          const chapter = subject?.chapters?.find(c => c.chapter_id === chapterId);
          if (chapter?.topics) {
            chapter.topics.forEach(topic => {
              const topicKey = `${subjectId}-${chapterId}-${topic.topic_id}`;
              newCheckedTopics[topicKey] = true;
            });
          }
        });
      });
    }
    // Manual selections - check only what's selected
    else if (selectedSubjects.length > 0) {
      selectedSubjects.forEach(subjectId => {
        selectedChapters.forEach(chapterId => {
          const chapterKey = `${subjectId}-${chapterId}`;
          newCheckedChapters[chapterKey] = true;

          selectedTopics.forEach(topicId => {
            const topicKey = `${subjectId}-${chapterId}-${topicId}`;
            newCheckedTopics[topicKey] = true;
          });
        });
      });
    }

    setCheckedSubjects(newCheckedSubjects);
    setCheckedChapters(newCheckedChapters);
    setCheckedTopics(newCheckedTopics);

    // Auto-expand
    // const expandedSubjs = {};
    // selectedSubjects.forEach(subjectId => {
    //   expandedSubjs[subjectId] = true;
    // });
    // setExpandedSubjects(expandedSubjs);

    // const expandedChaps = {};
    // selectedChapters.forEach(chapterId => {
    //   selectedSubjects.forEach(subjectId => {
    //     expandedChaps[`${subjectId}-${chapterId}`] = true;
    //   });
    // });
    // setExpandedChapters(expandedChaps);

  }, [selectedSubjects, selectedChapters, selectedTopics, importType, subjectsData]);

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">IMPORT QUESTIONS</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn">
            CANCEL
          </button>
          <button className="cr-create-btn" style={{ backgroundColor: `var(--MenuBackground)`, color: `var(--LoginInputBackground)`, border: "none" }}
            onClick={handleSyncAll}
          >
            SYNC ALL
          </button>
          <button 
            className="cr-create-btn" 
            style={{ 
              backgroundColor: "#2F2E40", 
              color: "var(--LoginInputBackground)", 
              border: "none",
              opacity: isImportEnabled() ? 1 : 0.5,
              cursor: isImportEnabled() ? 'pointer' : 'not-allowed'
            }}
            onClick={handleImport}
            disabled={!isImportEnabled()}
            title={!isImportEnabled() ? "Click APPLY first to enable import" : "Import selected questions"}
          >
            IMPORT
          </button>
        </div>
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>COURSE SELECTION</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <DropDown
                    label="Select Target Course"
                    selected={selectedCourse}
                    setSelected={(selectedOption) => {
                      setSelectedCourse(selectedOption || null);
                    }}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                          label: course.course_name,
                          id: course.course_id,
                        }))
                        : []
                    }
                    isRequired={true}
                    placeholder="Choose a course..."
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ques-paper-del" style={{ marginTop: '20px' }}>
        <div className="personal-header">
          <div className="header">
            <label>CURRENT STATUS (SUBJECT-WISE)</label>
          </div>
          <div className="accordion-btn" onClick={toggleStatusAccordion}>
            {isStatusOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isStatusOpen && (
          <div className="accordion-content">
            <div className="import-ques-status-container">
              <table className="status-table">
                <thead>
                  <tr>
                    <th>Subject Name</th>
                    <th>Source</th>
                    <th>Power Prep</th>
                    <th>Delta</th>
                    <th>Max Ques ID</th>
                  </tr>
                </thead>
                <tbody>
                  {subjectsData.map((subject) => {
                    const isExpanded = expandedSubjects[subject.subject_id];
                    const isChecked = checkedSubjects[subject.subject_id];
                    const showIcon = isChecked && subject.delta_count > 0;

                    return (
                      <React.Fragment key={subject.subject_id}>
                        {/* SUBJECT ROW */}
                        <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                          <td style={{ padding: '8px' }}>
                            <input
                              type="checkbox"
                              checked={isChecked || false}
                              onChange={() => handleSubjectCheck(subject.subject_id)}
                              ref={(el) => {
                                if (el && subject.chapters && subject.chapters.length > 0) {
                                  const totalChapters = subject.chapters.length;
                                  const checkedChaptersCount = subject.chapters.filter(ch => {
                                    const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                    return checkedChapters[chapterKey];
                                  }).length;
                                  el.indeterminate = checkedChaptersCount > 0 && checkedChaptersCount < totalChapters;
                                }
                              }}
                              className={
                                subject.chapters.length > 0 &&
                                  subject.chapters.every(ch => {
                                    const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                    return checkedChapters[chapterKey];
                                  })
                                  ? "delete-question-checkbox-dqc"
                                  : subject.chapters.length > 0 &&
                                    subject.chapters.some(ch => {
                                      const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                      return checkedChapters[chapterKey];
                                    })
                                    ? "expend-chapt-sub-check-box indeterminate"
                                    : "expend-chapt-sub-check-box"
                              }
                            />
                            <span
                              onClick={() => { if (!isChecked) return; subject.chapters.length > 0 && toggleExpandSubject(subject.subject_id); }}
                              style={{
                                marginRight: '8px',
                                cursor: subject.chapters.length > 0 ? 'pointer' : 'default',
                                fontWeight: 'bold',
                                color: `var(--DropdownPlaceholderText)`,
                                cursor: isChecked ? "pointer" : "not-allowed",
                                opacity: isChecked ? 1 : 0.5,
                              }}
                            >
                              {subject.chapters.length > 0 ? (isExpanded ? '−' : '+') : ''}
                            </span>
                            <span
                              title={subject.subject_name}
                              style={{
                                color: `var(--DropdownPlaceholderText)`,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'inline-block',
                                maxWidth: 'calc(100% - 30px)',
                              }}
                            >
                              {subject.subject_name}
                            </span>
                          </td>
                          <td style={{ textAlign: 'center', padding: '8px' }}>{subject.source_question_count}</td>
                          <td style={{ textAlign: 'center', padding: '8px' }}>
                            {subject.destination_question_count}
                          </td>
                          <td style={{ textAlign: 'center', padding: '8px' }}>
                            <span>{subject.delta_count > 0 ? `+${subject.delta_count}` : subject.delta_count}</span>
                            {/* {showIcon && (
                              <span className="import-icon-container">
                                <FaFileImport />
                                <span className="import-tooltip">Import {subject.delta_count} Questions</span>
                              </span>
                            )} */}
                            {showIcon && (
                              <span
                                className="import-icon-container"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setImportType('incremental');
                                  setSelectedSubjects([subject.subject_id]);
                                  setSelectedChapters([]);
                                  setSelectedTopics([]);

                                  // Trigger fetch with subject-level payload
                                  setTimeout(() => {
                                    setImportFilterPayload({
                                      subject_ids: [subject.subject_id],
                                      chapter_ids: [],
                                      topic_ids: []
                                    });
                                    const tempPayload = {
                                      from_date: "",
                                      subject_ids: [subject.subject_id],
                                      chapter_ids: [],
                                      topic_ids: [],
                                      parse_ques_set_question_ids: []
                                    };
                                    fetchProjectedData(tempPayload);
                                  }, 0);
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <FaFileImport />
                                <span className="import-tooltip">Import {subject.delta_count} Questions</span>
                              </span>
                            )}
                          </td>
                          <td style={{ textAlign: 'center', padding: '8px' }}>{subject.max_question_id}</td>
                        </tr>

                        {/* CHAPTERS ROWS - NO NESTED TABLE */}
                        {isExpanded &&
                          subject.chapters.map((chapter) => {
                            const chapterKey = `${subject.subject_id}-${chapter.chapter_id}`;
                            const isChapterExpanded = expandedChapters[chapterKey];
                            const isChapterChecked = checkedChapters[chapterKey];
                            const showChapterIcon = isChapterChecked && chapter.delta_count > 0;

                            return (
                              <React.Fragment key={chapterKey}>
                                {/* CHAPTER ROW */}
                                <tr style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: '#fafafa' }}>
                                  <td style={{ padding: '8px 12px', paddingLeft: '32px' }}>
                                    <input
                                      type="checkbox"
                                      checked={isChapterChecked || false}
                                      onChange={() => handleChapterCheck(subject.subject_id, chapter.chapter_id)}
                                      ref={(el) => {
                                        if (el && chapter.topics && chapter.topics.length > 0) {
                                          const totalTopics = chapter.topics.length;
                                          const checkedTopicsCount = chapter.topics.filter(topic => {
                                            const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                            return checkedTopics[topicKey];
                                          }).length;

                                          el.indeterminate = checkedTopicsCount > 0 && checkedTopicsCount < totalTopics;
                                        }
                                      }}
                                      className={
                                        chapter.topics.length > 0 &&
                                          chapter.topics.every(topic => {
                                            const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                            return checkedTopics[topicKey];
                                          })
                                          ? "delete-question-checkbox-dqc"
                                          : chapter.topics.length > 0 &&
                                            chapter.topics.some(topic => {
                                              const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                              return checkedTopics[topicKey];
                                            })
                                            ? "expend-chapt-sub-check-box indeterminate"
                                            : "expend-chapt-sub-check-box"
                                      }
                                    />
                                    <span
                                      onClick={() =>
                                        chapter.topics.length > 0 &&
                                        toggleExpandChapter(subject.subject_id, chapter.chapter_id)
                                      }
                                      style={{
                                        marginRight: '8px',
                                        cursor: chapter.topics.length > 0 ? 'pointer' : 'default',
                                        fontWeight: 'bold',
                                        color: `var(--DropdownPlaceholderText)`,
                                      }}
                                    >
                                      {chapter.topics.length > 0 ? (isChapterExpanded ? '−' : '+') : ''}
                                    </span>
                                    <span
                                      title={chapter.chapter_name}
                                      style={{
                                        color: `var(--DropdownPlaceholderText)`,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: 'inline-block',
                                        maxWidth: 'calc(100% - 40px)',
                                      }}
                                    >
                                      {chapter.chapter_name}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>
                                    {chapter.source_question_count}
                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>
                                    {chapter.destination_question_count}

                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px', }} >
                                    <span>{chapter.delta_count > 0 ? `+${chapter.delta_count}` : chapter.delta_count}</span>
                                    {/* {showIcon && (
                                      <span className="import-icon-container">
                                        <FaFileImport />
                                        <span className="import-tooltip">Import {chapter.delta_count} Questions</span>
                                      </span>
                                    )} */}
                                    {showChapterIcon && (
                                      <span
                                        className="import-icon-container"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setImportType('incremental');
                                          setSelectedSubjects([subject.subject_id]);
                                          setSelectedChapters([chapter.chapter_id]);
                                          setSelectedTopics([]);

                                          // Trigger fetch with chapter-level payload
                                          setTimeout(() => {
                                            setImportFilterPayload({
                                              subject_ids: [subject.subject_id],
                                              chapter_ids: [chapter.chapter_id],
                                              topic_ids: []
                                            });
                                            const tempPayload = {
                                              from_date: "",
                                              subject_ids: [subject.subject_id],
                                              chapter_ids: [chapter.chapter_id],
                                              topic_ids: [],
                                              parse_ques_set_question_ids: []
                                            };
                                            fetchProjectedData(tempPayload);
                                          }, 0);
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <FaFileImport />
                                        <span className="import-tooltip">Import {chapter.delta_count} Questions</span>
                                      </span>
                                    )}
                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>{chapter.max_question_id}</td>
                                </tr>

                                {/* TOPICS ROWS */}
                                {isChapterExpanded &&
                                  chapter.topics.map((topic) => {
                                    const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                    const isTopicChecked = checkedTopics[topicKey];
                                    const showTopicIcon = isTopicChecked && topic.delta_count > 0;

                                    return (
                                      <tr
                                        key={topicKey}
                                        style={{
                                          borderBottom: '1px solid #f3f4f6',
                                          backgroundColor: `var(ColumnSelectionDropdownBackground)`,
                                        }}
                                      >
                                        <td style={{ padding: '6px 12px', paddingLeft: '56px' }}>
                                          <input
                                            type="checkbox"
                                            checked={isTopicChecked || false}
                                            onChange={() =>
                                              handleTopicCheck(subject.subject_id, chapter.chapter_id, topic.topic_id)
                                            }
                                            className="delete-question-checkbox-dqc"
                                          />
                                          <span
                                            title={topic.topic_name}
                                            style={{
                                              color: `var(--DropdownPlaceholderText)`,
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              display: 'inline-block',
                                              maxWidth: 'calc(100% - 30px)',
                                            }}
                                          >
                                            {topic.topic_name}
                                          </span>
                                        </td>
                                        <td style={{ textAlign: 'center', padding: '6px 12px' }}>
                                          {topic.source_question_count}
                                        </td>
                                        <td style={{ textAlign: 'center', padding: '6px 12px' }}>
                                          {topic.destination_question_count}
                                        </td>
                                        <td style={{ textAlign: 'center', padding: '6px 12px', }} >
                                          <span>{topic.delta_count > 0 ? `+${topic.delta_count}` : topic.delta_count}</span>
                                          {/* {showIcon && (
                                            <span className="import-icon-container">
                                              <FaFileImport />
                                              <span className="import-tooltip">Import {topic.delta_count} Questions</span>
                                            </span>
                                          )} */}
                                          {showTopicIcon && (
                                            <span
                                              className="import-icon-container"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setImportType('incremental');
                                                setSelectedSubjects([subject.subject_id]);
                                                setSelectedChapters([chapter.chapter_id]);
                                                setSelectedTopics([topic.topic_id]);

                                                // Trigger fetch with topic-level payload
                                                setTimeout(() => {
                                                  setImportFilterPayload({
                                                    subject_ids: [subject.subject_id],
                                                    chapter_ids: [chapter.chapter_id],
                                                    topic_ids: [topic.topic_id]
                                                  });
                                                  const tempPayload = {
                                                    from_date: "",
                                                    subject_ids: [subject.subject_id],
                                                    chapter_ids: [chapter.chapter_id],
                                                    topic_ids: [topic.topic_id],
                                                    parse_ques_set_question_ids: []
                                                  };
                                                  fetchProjectedData(tempPayload);
                                                }, 0);
                                              }}
                                              style={{ cursor: 'pointer' }}
                                            >
                                              <FaFileImport />
                                              <span className="import-tooltip">Import {topic.delta_count} Questions</span>
                                            </span>
                                          )}
                                        </td>
                                        <td style={{ textAlign: 'center', padding: '6px 12px' }}>
                                          {topic.max_question_id}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
              <div style={{ marginTop: '6px', padding: '12px', fontSize: '12px', color: `var(--DropdownPlaceholderText)` }}>
                Summary: Source: {totals.source || 0} | Destination: {totals.destination || 0} | Delta: {totals.delta || 0}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ques-paper-del" style={{ marginTop: '20px' }} ref={projectedSectionRef}>
        <div className="personal-header">
          <div className="header">
            <label>IMPORT CRITERIA</label>
          </div>
          <div className="accordion-btn" onClick={toggleCriteriaAccordion}>
            {isCriteriaOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isCriteriaOpen && (
          <div className="accordion-content">
            {/* <div className="import-ques-criteria-container"> */}
             <div className="import-ques-status-container">
              <div className="import-ques-criteria-option">
                <div className="import-ques-criteria-radio-group">
                  <input
                    type="radio"
                    id="incremental"
                    name="importType"
                    value="incremental"
                    checked={importType === 'incremental'}
                    onChange={(e) => setImportType(e.target.value)}
                    className="import-ques-radio-input"
                  />
                  <label htmlFor="incremental" className="import-ques-radio-label">
                    <span className="import-ques-option-title">Incremental Import</span>
                  </label>
                </div>
                <p className="import-ques-option-description">
                  Import only new questions added since the last successful sync operation.
                </p>
                <div className="import-ques-criteria-fields">
                  <div className="import-ques-field-row">
                    <div className="import-ques-field">
                      <MultiSeledDropdown
                        label="Subjects"
                        width="100%"
                        selected={selectedSubjects}
                        setSelected={setSelectedSubjects}
                        options={subjectOptions}
                        showSelectAll={true}
                      />
                    </div>
                    <div className="import-ques-field">
                      <MultiSeledDropdown
                        label="Chapters"
                        width="100%"
                        selected={selectedChapters}
                        setSelected={setSelectedChapters}
                        options={chapterOptions}
                        showSelectAll={true}
                      />
                    </div>
                    <div className="import-ques-field">
                      <MultiSeledDropdown
                        label="Topics"
                        width="100%"
                        selected={selectedTopics}  // Change this
                        setSelected={setSelectedTopics}  // Change this
                        options={topicOptions}
                        showSelectAll={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="import-ques-criteria-option">
                <div className="import-ques-criteria-radio-group">
                  <input
                    type="radio"
                    id="specific"
                    name="importType"
                    value="specific"
                    checked={importType === 'specific'}
                    onChange={(e) => setImportType(e.target.value)}
                    className="import-ques-radio-input"
                  />
                  <label htmlFor="specific" className="import-ques-radio-label">
                    <span className="import-ques-option-title">Specific Question IDs / Range</span>
                  </label>
                </div>
                <p className="import-ques-option-description">
                  Manually specify IDs or ranges to force import specific questions. Format: Single IDs (e.g., 100, 200) or ranges (e.g., 1000-1500).
                </p>
                <div className="import-ques-criteria-fields">
                  <div className="import-ques-field-row">
                    <div className="import-ques-field">
                      <FormInputs
                        label="Range"
                        width="100%"
                        type="text"
                        name="range"
                        placeholder="e.g. 100, 1000-1500, 1111-3333"
                        value={rangeValue}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^[0-9,\-\s]*$/.test(val)) {
                            setRangeValue(val);
                          }
                        }}
                        pattern="^(\d+|\d+-\d+)(,\s*(\d+|\d+-\d+))*$"
                      />
                    </div>
                  </div>
                  {filteredQuestionsByRange.length > 0 && importType === 'specific' && (
                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
                      <p style={{ fontSize: '12px', color: 'var(--DropdownPlaceholderText)' }}>
                        <strong>Found {filteredQuestionsByRange.length} valid question(s):</strong> {filteredQuestionsByRange.slice(0, 10).join(', ')}{filteredQuestionsByRange.length > 10 ? '...' : ''}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="import-ques-criteria-option">
                <div className="import-ques-criteria-radio-group">
                  <input
                    type="radio"
                    id="dateImport"
                    name="importType"
                    value="date"
                    checked={importType === 'date'}
                    onChange={(e) => setImportType(e.target.value)}
                    className="import-ques-radio-input"
                  />
                  <label htmlFor="dateImport" className="import-ques-radio-label">
                    <span className="import-ques-option-title">Last Updated Since Date</span>
                  </label>
                </div>
                <p className="import-ques-option-description">
                  Import questions modified after a specific calendar date.
                </p>
                <div className="import-ques-criteria-fields">
                  <div className="import-ques-field-row">
                    <FormInputs
                      label="Date"
                      type="date"
                      value={lastUpdatedDate}
                      onChange={(e) => setLastUpdatedDate(e.target.value)}
                      placeholder="mm/dd/yyyy"
                    />
                    <div className="import-ques-field">
                      <MultiSeledDropdown
                        label="Subjects"
                        width="100%"
                        selected={selectedSubjectsForDate}
                        setSelected={setSelectedSubjectsForDate}
                        options={subjectOptions}
                        showSelectAll={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="import-ques-criteria-option">
                <div className="import-ques-criteria-radio-group">
                  <input
                    type="radio"
                    id="dateImport"
                    name="byset"
                    value="byset"
                    checked={importType === 'byset'}
                    onChange={(e) => setImportType(e.target.value)}
                    className="import-ques-radio-input"
                  />
                  <label htmlFor="dateImport" className="import-ques-radio-label">
                    <span className="import-ques-option-title">By Set</span>
                  </label>
                </div>
                <p className="import-ques-option-description">
                  Import Set.
                </p>

                <div className="import-ques-criteria-fields">
                  <div className="import-ques-field-row">
                    <div className="import-ques-field">
                      <div className="import-ques-field">
                        <MultiSeledDropdown
                          label="Set"
                          width="100%"
                          selected={selectedSets}
                          setSelected={setSelectedSets}
                          options={setOptions}
                          showSelectAll={true}
                          placeholder="Select Set"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="import-ques-criteria-actions">
                <button className="import-ques-apply-btn" onClick={handleApply}>
                  APPLY
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ques-paper-del" style={{ marginTop: '20px' }}>
        <div className="personal-header">
          <div className="header">
            <label>SUBJECT-WISE NEW STATUS (PROJECTED)</label>
          </div>
          <div className="accordion-btn" onClick={toggleProjectedAccordion}>
            {isProjectedOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isProjectedOpen && (
          <div className="accordion-content">
            <div className="import-ques-status-container">
              <table className="status-table">
                <thead>
                  <tr>
                    <th>Subject Name</th>
                    <th>New Questions</th>
                    <th>Updated Questions</th>
                    <th>Projected Total</th>
                  </tr>
                </thead>
                <tbody>
                  {projectedData.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: 'var(--DropdownPlaceholderText)' }}>
                        No data available. Click APPLY to see projected status.
                      </td>
                    </tr>
                  ) : (
                    projectedData.map((subject) => {
                      const isExpanded = expandedProjectedSubjects[subject.subject_id];
                      const isChecked = checkedProjectedSubjects[subject.subject_id];
                      const showIcon = isChecked && subject.new_questions > 0;

                      return (
                        <React.Fragment key={subject.subject_id}>
                          <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                            <td style={{ padding: '8px' }}>
                              <input
                                type="checkbox"
                                checked={isChecked || false}
                                onChange={() => handleProjectedSubjectCheck(subject.subject_id)}
                                ref={(el) => {
                                  if (el && subject.chapters && subject.chapters.length > 0) {
                                    const totalChapters = subject.chapters.length;
                                    const checkedChaptersCount = subject.chapters.filter(ch => {
                                      const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                      return checkedProjectedChapters[chapterKey];
                                    }).length;

                                    el.indeterminate = checkedChaptersCount > 0 && checkedChaptersCount < totalChapters;
                                  }
                                }}
                                className={
                                  subject.chapters && subject.chapters.length > 0 &&
                                    subject.chapters.every(ch => {
                                      const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                      return checkedProjectedChapters[chapterKey];
                                    })
                                    ? "delete-question-checkbox-dqc"
                                    : subject.chapters && subject.chapters.length > 0 &&
                                      subject.chapters.some(ch => {
                                        const chapterKey = `${subject.subject_id}-${ch.chapter_id}`;
                                        return checkedProjectedChapters[chapterKey];
                                      })
                                      ? "expend-chapt-sub-check-box indeterminate"
                                      : "expend-chapt-sub-check-box"
                                }
                              />
                              <span
                                onClick={() => {
                                  if (!isChecked) return;
                                  subject.chapters && subject.chapters.length > 0 && toggleExpandProjectedSubject(subject.subject_id);
                                }}
                                style={{
                                  marginRight: '8px',
                                  cursor: subject.chapters && subject.chapters.length > 0 ? 'pointer' : 'default',
                                  fontWeight: 'bold',
                                  color: 'var(--DropdownPlaceholderText)',
                                  cursor: isChecked ? "pointer" : "not-allowed",
                                  opacity: isChecked ? 1 : 0.5,
                                }}
                              >
                                {subject.chapters && subject.chapters.length > 0 ? (isExpanded ? '−' : '+') : ''}
                              </span>
                              <span
                                title={subject.subject_name}
                                style={{
                                  color: 'var(--DropdownPlaceholderText)',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  display: 'inline-block',
                                  maxWidth: 'calc(100% - 30px)',
                                }}
                              >
                                {subject.subject_name}
                              </span>
                            </td>
                            <td style={{ textAlign: 'center', padding: '8px' }}>
                              <span style={{ marginRight: '10px' }}>
                                {(() => {
                                  const initialDelta = initialDeltaCounts[`subject_${subject.subject_id}`] || 0;
                                  return initialDelta > 0 ? `+${initialDelta}` : initialDelta;
                                })()}
                              </span>
                            </td>
                            <td style={{ textAlign: 'center', padding: '8px' }}>{subject.updated_questions || 0}</td>
                            <td style={{ textAlign: 'center', padding: '8px' }}>{subject.projected_total || 0}</td>
                          </tr>
                          {isExpanded && subject.chapters && subject.chapters.map((chapter) => {
                            const chapterKey = `${subject.subject_id}-${chapter.chapter_id}`;
                            const isChapterExpanded = expandedProjectedChapters[chapterKey];
                            const isChapterChecked = checkedProjectedChapters[chapterKey];
                            const showChapterIcon = isChapterChecked && chapter.new_questions > 0;

                            return (
                              <React.Fragment key={chapterKey}>
                                <tr style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: '#fafafa' }}>
                                  <td style={{ padding: '8px 12px', paddingLeft: '32px' }}>
                                    <input
                                      type="checkbox"
                                      checked={isChapterChecked || false}
                                      onChange={() => handleProjectedChapterCheck(subject.subject_id, chapter.chapter_id)}
                                      ref={(el) => {
                                        if (el && chapter.topics && chapter.topics.length > 0) {
                                          const totalTopics = chapter.topics.length;
                                          const checkedTopicsCount = chapter.topics.filter(topic => {
                                            const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                            return checkedProjectedTopics[topicKey];
                                          }).length;

                                          el.indeterminate = checkedTopicsCount > 0 && checkedTopicsCount < totalTopics;
                                        }
                                      }}
                                      className={
                                        chapter.topics && chapter.topics.length > 0 &&
                                          chapter.topics.every(topic => {
                                            const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                            return checkedProjectedTopics[topicKey];
                                          })
                                          ? "delete-question-checkbox-dqc"
                                          : chapter.topics && chapter.topics.length > 0 &&
                                            chapter.topics.some(topic => {
                                              const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                              return checkedProjectedTopics[topicKey];
                                            })
                                            ? "expend-chapt-sub-check-box indeterminate"
                                            : "expend-chapt-sub-check-box"
                                      }
                                    />
                                    <span
                                      onClick={() =>
                                        chapter.topics && chapter.topics.length > 0 &&
                                        toggleExpandProjectedChapter(subject.subject_id, chapter.chapter_id)
                                      }
                                      style={{
                                        marginRight: '8px',
                                        cursor: chapter.topics && chapter.topics.length > 0 ? 'pointer' : 'default',
                                        fontWeight: 'bold',
                                        color: 'var(--DropdownPlaceholderText)',
                                      }}
                                    >
                                      {chapter.topics && chapter.topics.length > 0 ? (isChapterExpanded ? '−' : '+') : ''}
                                    </span>
                                    <span
                                      title={chapter.chapter_name}
                                      style={{
                                        color: 'var(--DropdownPlaceholderText)',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: 'inline-block',
                                        maxWidth: 'calc(100% - 40px)',
                                      }}
                                    >
                                      {chapter.chapter_name}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>
                                    <span style={{ marginRight: '10px' }}>
                                      {(() => {
                                        const initialDelta = initialDeltaCounts[`chapter_${subject.subject_id}_${chapter.chapter_id}`] || 0;
                                        return initialDelta > 0 ? `+${initialDelta}` : initialDelta;
                                      })()}
                                    </span>
                                  </td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>{chapter.updated_questions || 0}</td>
                                  <td style={{ textAlign: 'center', padding: '8px 12px' }}>{chapter.projected_total || 0}</td>
                                </tr>

                                {isChapterExpanded && chapter.topics && chapter.topics.map((topic) => {
                                  const topicKey = `${subject.subject_id}-${chapter.chapter_id}-${topic.topic_id}`;
                                  const isTopicChecked = checkedProjectedTopics[topicKey];
                                  const showTopicIcon = isTopicChecked && topic.new_questions > 0;

                                  return (
                                    <tr
                                      key={topicKey}
                                      style={{
                                        borderBottom: '1px solid #f3f4f6',
                                        backgroundColor: 'var(--ColumnSelectionDropdownBackground)',
                                      }}
                                    >
                                      <td style={{ padding: '6px 12px', paddingLeft: '56px' }}>
                                        <input
                                          type="checkbox"
                                          checked={isTopicChecked || false}
                                          onChange={() => handleProjectedTopicCheck(subject.subject_id, chapter.chapter_id, topic.topic_id)}
                                          className="delete-question-checkbox-dqc"
                                        />
                                        <span
                                          title={topic.topic_name}
                                          style={{
                                            color: 'var(--DropdownPlaceholderText)',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            display: 'inline-block',
                                            maxWidth: 'calc(100% - 30px)',
                                          }}
                                        >
                                          {topic.topic_name}
                                        </span>
                                      </td>
                                      <td style={{ textAlign: 'center', padding: '6px 12px' }}>
                                        <span style={{ marginRight: '10px' }}>
                                          {(() => {
                                            const initialDelta = initialDeltaCounts[`topic_${subject.subject_id}_${chapter.chapter_id}_${topic.topic_id}`] || 0;
                                            return initialDelta > 0 ? `+${initialDelta}` : initialDelta;
                                          })()}
                                        </span>
                                      </td>
                                      <td style={{ textAlign: 'center', padding: '6px 12px' }}>{topic.updated_questions || 0}</td>
                                      <td style={{ textAlign: 'center', padding: '6px 12px' }}>{topic.projected_total || 0}</td>
                                    </tr>
                                  );
                                })}
                              </React.Fragment>
                            );
                          })}
                        </React.Fragment>
                      );
                    })
                  )}
                </tbody>
              </table>
              {/* <div style={{ marginTop: '6px', padding: '12px', fontSize: '12px', color: 'var(--DropdownPlaceholderText)' }}>
                Last import successfully completed on 17 Jan 2026 at 3:00 PM
              </div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ImportQuestions;



































// const [lastImportDate, setLastImportDate] = useState('');
// const getCurrentFormattedDateTime = () => {
//   const now = new Date();

//   const day = now.getDate();
//   const month = now.toLocaleString('en-US', { month: 'short' });
//   const year = now.getFullYear();

//   let hours = now.getHours();
//   const minutes = now.getMinutes();
//   const ampm = hours >= 12 ? 'PM' : 'AM';

//   hours = hours % 12;
//   hours = hours ? hours : 12; // the hour '0' should be '12'
//   const minutesStr = minutes < 10 ? '0' + minutes : minutes;

//   return `${day} ${month} ${year} at ${hours}:${minutesStr} ${ampm}`;
// };


//  fetchProjectedData(payload);

//   // Set the current date-time when Apply is clicked
//   setLastImportDate(getCurrentFormattedDateTime());


{/* <div style={{ marginTop: '6px', padding: '12px', fontSize: '12px', color: 'var(--DropdownPlaceholderText)' }}>
  {lastImportDate ? (
    `Last import successfully completed on ${lastImportDate}`
  ) : (
    'No import completed yet'
  )}
</div> */}


